'use client';

export type OperationsSyncSource = 'smarttask' | 'forms' | 'inventory';

export interface OperationsSyncActivityDetail {
  source: OperationsSyncSource;
  phase: 'start' | 'progress' | 'complete' | 'error';
  message?: string;
  error?: string;
}

export const OPERATIONS_SYNC_ACTIVITY_EVENT = 'operations-sync-activity';
export const OPERATIONS_SYNC_PENDING_CHANGED_EVENT = 'operations-sync-pending-changed';

export function emitOperationsSyncActivity(detail: OperationsSyncActivityDetail): void {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(OPERATIONS_SYNC_ACTIVITY_EVENT, {
    detail,
  }));
}

export function emitOperationsSyncPendingChanged(source?: OperationsSyncSource): void {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(OPERATIONS_SYNC_PENDING_CHANGED_EVENT, {
    detail: {
      source,
      at: new Date().toISOString(),
    },
  }));
}